import React, {useEffect, useState} from "react";
import tacitLogoMedium from "assets/img/logo/logo_379px.png";
import Cookies from 'universal-cookie';
import {
    Box,
    Flex,
    Image,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Select,
    Spacer,
    Spinner,
    useToast
} from "@chakra-ui/react";
import HeaderButtonGroup from "components/headers/HeaderButtonGroup"
import HeaderButtonGroupThemes from "components/headers/HeaderButtonGroupThemes"
import {gql, useQuery} from "@apollo/client";
import {FiSettings} from "react-icons/fi";
import * as FullStory from '@fullstory/browser';
import {Redirect, Route, Switch, useHistory} from "react-router-dom";
import ProductsIndex from "views/admin/products/index"
import {PlatformBrandContext} from "contexts/PlatformContext"
import AnalyzePage from "../../views/admin/products/analyze";
import SearchPage from "../../views/admin/search";
import ProductComparisonPage from "../../views/admin/products/comparePage";
import AnalyzeAspects from "../../views/admin/analyzeAspects";
import {getAuth, signOut, onAuthStateChanged} from "firebase/auth";
import {getDatabase} from "firebase/database";
import ThemesPage from "../../views/home/themes/ThemesPage";
import ThemeTopicsPage from "../../views/home/themes/ThemeTopics";


function AnalysisLayoutNeedAuth({user, token}) {
    const [platformsState, setPlatformsState] = useState([])
    const [brandsState, _] = useState([])
    const customer = localStorage.getItem("customerName");
    useEffect(() => document.body.style.backgroundColor = "#EEEEEE")
    useEffect(() => {
        //CRISP CHAT INTEGRATION
        window.$crisp = [];
        window.CRISP_WEBSITE_ID = "345c727e-f40a-42ac-bb5d-5420f000f73a";
        (function () {
            let d = document;
            let s = d.createElement("script");
            s.src = "https://client.crisp.chat/l.js";
            s.async = 1;
            d.getElementsByTagName("head")[0].appendChild(s);
        })();
        window.$crisp.push(["set", "user:email", user.email]);
    }, [])
    const history = useHistory();
    const toast = useToast();

    const {loading, error, data} = useQuery(gql`
    query CustomerPlatforms($customer_name: String = "") {
        customer_platforms(where: {customer: {_eq: $customer_name}}) {
            platform
            platformByPlatform {
              platform_name
            }
          }
          customer_brands(where: {customer: {_eq: $customer_name}}) {
            brand
            brand_pretty_name
          }
        }
    `, {
        variables: {customer_name: localStorage.getItem("customerName")},
    });
    console.log("process.env.HASURA_GRAPHQL_API", process.env.REACT_APP_HASURA_GRAPHQL_API);


    function platformSelectionChangeHandle(e) {
        if (e.target.value === "all_platforms") {
            setPlatformsState(data.customer_platforms.map(x => x.platform));
        } else {
            setPlatformsState([e.target.value]);
        }
    }

    function signout() {
        const auth = getAuth();
        signOut(auth).then(() => {
            const cookies = new Cookies();
            cookies.remove('jwtToken', {path: '/'});
            history.push('/home')
        }).catch((error) => {
            console.log("Can't logout", error);
            toast({
                title: `Error: Cannot logout ${error.message}`,
                status: 'info', 'isClosable': true,
                duration: 4000
            })
        });
    }

    if (loading) return <Box pt={{base: "130px", md: "80px", xl: "80px"}} ml={"200px"}><Spinner size='xl'/></Box>
    if (error) return `Error! ${error.message}`;
    let platforms = platformsState.length > 0 ? platformsState : data?.customer_platforms.map(x => x.platform)
    let allBrands = brandsState.length > 0 ? brandsState : data?.customer_brands
    console.log("PLATFORMS", platforms)
    console.log("ALLBRANDSS", allBrands)
    return (
        <Box>
            <PlatformBrandContext.Provider
                value={{
                    platforms: platforms,
                    allBrands: allBrands,
                }}>
                <Flex align='center' justify='center'>
                    <Box m='20px 30px' p='8px 0px' h='64px' w='100%' borderRadius='3px'>
                        <Flex flexDirection='row' align='center'>
                            <Image src={tacitLogoMedium} h='24px' ml='0px'/>
                            <Box>
                                {customer === 'healthkart' ? <HeaderButtonGroup/>
                                    : <HeaderButtonGroupThemes/>}
                            </Box>
                            <Spacer/>
                            {loading ? <Select isDisabled/> :
                                <Select variant='filled' backgroundColor='#FFF' borderRadius='10px' w='300px'
                                        onChange={platformSelectionChangeHandle}
                                >
                                    <option value="all_platforms">All
                                        Platforms
                                    </option>
                                    {data?.customer_platforms.map((x, i) =>
                                        <option key={i}
                                                value={[x.platform]}>{x.platformByPlatform.platform_name}</option>)}
                                </Select>}
                            <Box ml='30px' height='24px'>
                                <Menu>
                                    <MenuButton>
                                        <FiSettings size='24px'/>
                                    </MenuButton>
                                    <MenuList borderRadius='10px'
                                              zIndex="12"> {/** 12 because apexcharts hamburger menu uses z-index of 11 **/}

                                        <MenuItem onClick={signout}>Log out...</MenuItem>
                                    </MenuList>
                                </Menu>
                            </Box>
                        </Flex>
                    </Box>
                </Flex>
                <Switch>
                    <Route path={'/home/products/analyze/'} key='2' component={AnalyzePage}/>
                    <Route path={'/home/products/compare'} key='4' component={ProductComparisonPage}/>
                    <Route path={'/home/products/'} key='1' component={ProductsIndex}/>
                    <Route path={'/home/analyze-aspects'} component={AnalyzeAspects}/>
                    <Route path={'/home/search/'} key='3' component={SearchPage}/>
                    <Route path={'/home/themes/'} key='5' component={ThemesPage}/>
                    <Route path={'/home/analyzeTheme'} key='6' component={ThemeTopicsPage}/>
                    <Redirect from='/' to='/home/themes'/>
                </Switch>
            </PlatformBrandContext.Provider>
        </Box>
    )
}

export default function AnalysisLayout() {

    const history = useHistory();
    const auth = getAuth();
    const [user, setUser] = useState();
    const [authorized, setAuthorized] = useState(false);
    const [authState, setAuthState] = useState({status: "loading"});

    useEffect(() => {
        onAuthStateChanged(auth, async (user) => {

            if (!user) {
                setAuthorized(false);
                history.replace('/auth/login')
            } else {
                console.log("Logged in ")
                console.log("USER", user)
                FullStory.identify(user.email)

                const token = await user.getIdToken();
                const idTokenResult = await user.getIdTokenResult();
                const hasuraClaim =
                    idTokenResult.claims["https://hasura.io/jwt/claims"];
                if (hasuraClaim) {
                    const cookies = new Cookies();
                    cookies.set('jwtToken', token, {path: '/', sameSite: 'strict'});
                    localStorage.setItem('customerName', hasuraClaim['x-hasura-customer'])
                    setAuthState({status: "in", "user": user, "token": token});

                } else {
                    // Check if refresh is required.
                    const metadataRef = getDatabase()
                        .ref("metadata/" + user.uid + "/refreshTime");

                    metadataRef.on("value", async (data) => {
                        if (!data.exists) return
                        // Force refresh to pick up the latest custom claims changes.
                        const token = await user.getIdToken(true);
                        setAuthState({status: "in", "user": user, "token": token});
                    });
                }
                setUser(user);
                setAuthorized(true);
            }
        })
    }, [user])
    return (
        <>
            {authorized ? <AnalysisLayoutNeedAuth user={user} token={authState.token}/> : (
                <Box pt={{base: "130px", md: "80px", xl: "80px"}} ml={"200px"}><Spinner/></Box>)
            }
        </>
    )


}